import { render, staticRenderFns } from "./vehicle-cross-selling.vue?vue&type=template&id=b7220170&"
import script from "./vehicle-cross-selling.vue?vue&type=script&lang=js&"
export * from "./vehicle-cross-selling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports